import { render, staticRenderFns } from "./CustomerSiteSidebar.vue?vue&type=template&id=f18b269a"
import script from "./CustomerSiteSidebar.vue?vue&type=script&lang=js"
export * from "./CustomerSiteSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f18b269a')) {
      api.createRecord('f18b269a', component.options)
    } else {
      api.reload('f18b269a', component.options)
    }
    module.hot.accept("./CustomerSiteSidebar.vue?vue&type=template&id=f18b269a", function () {
      api.rerender('f18b269a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/CustomerSiteSidebar.vue"
export default component.exports